import { ReactNode } from 'react';
import { Card, Title, Chip } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { Text, Link, Stack } from '@tiendanube/components';
import { EditIcon } from '@tiendanube/icons';
import { AiNavigationAttributes } from 'commons/hooks';
import { onChangeTagsType } from '../../TagsAndSeo';

interface ShowTagsAndSeoCardProps {
  tags: string[];
  slot: ReactNode;
  onOpen: () => void;
  onChange: onChangeTagsType;
  aiGeneratedTags?: string[];
  aiNavigationAttributes?: AiNavigationAttributes;
}

function ShowTagsAndSeoCard({
  tags,
  slot,
  onOpen,
  onChange,
  aiGeneratedTags,
  aiNavigationAttributes,
}: ShowTagsAndSeoCardProps): JSX.Element {
  const { t } = useTranslation(Domain.CATALOG);

  const handleOnRemoveTag = (index: number) => {
    const newTags = [...tags];
    newTags.splice(index, 1);
    onChange({ name: 'tags', value: newTags });
  };

  return (
    <Card id="tags-and-seo-card" {...aiNavigationAttributes}>
      <Card.Header>
        <Stack spacing="tight">
          <Title as="h4">{t('products.detail.tags.title')}</Title>
          {slot}
        </Stack>
      </Card.Header>
      <Card.Body>
        <Stack column align="stretch">
          <Stack.Item>
            <Text>{t('products.detail.tags.descriptionCard')}</Text>
          </Stack.Item>
          {tags.length > 0 && (
            <Stack spacing="tight" wrap>
              {tags.map((tag, index) => (
                <Chip
                  key={index}
                  id={`${index}`}
                  text={tag}
                  removable
                  onClick={() => handleOnRemoveTag(index)}
                  aiGenerated={aiGeneratedTags?.includes(tag)}
                />
              ))}
            </Stack>
          )}
          <Stack.Item>
            <Link
              icon={EditIcon}
              iconPosition="start"
              appearance="primary"
              onClick={onOpen}
            >
              {t('products.detail.tags.edit')}
            </Link>
          </Stack.Item>
        </Stack>
      </Card.Body>
    </Card>
  );
}

export default ShowTagsAndSeoCard;
